package com.essntl.features.proposal.ui.addeditproposal.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import com.essntl.features.address.ui.AddressEvent
import com.essntl.features.address.ui.AddressState
import com.essntl.features.address.ui.AddressValidation
import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.contact.ui.ContactValidation
import com.essntl.features.crm.ui.contactorganization.ContactOrganizationEvent
import com.essntl.features.crm.ui.contactorganization.ContactOrganizationScreen
import com.essntl.features.crm.ui.contactorganization.ContactOrganizationState
import com.essntl.features.customfields.ui.CustomFieldsEvent
import com.essntl.features.customfields.ui.CustomFieldsState
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.organization.ui.OrganizationEvent
import com.essntl.features.organization.ui.OrganizationState
import com.essntl.features.organization.ui.OrganizationValidation
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ContactOrganizationDialog(
    isOpen: Boolean,
    onDismissRequest: () -> Unit,
    type: OrganizationModel.Type,
    state: ContactOrganizationState,
    onEvent: (ContactOrganizationEvent) -> Unit,
    organizationState: OrganizationState,
    onOrganizationEvent: (OrganizationEvent) -> Unit,
    organizationValidation: OrganizationValidation,
    organizationAddressState: AddressState,
    onOrganizationAddressEvent: (AddressEvent) -> Unit,
    organizationAddressValidation: AddressValidation,
    contactState: ContactState,
    onContactEvent: (ContactEvent) -> Unit,
    contactValidation: ContactValidation,
    contactAddressState: AddressState,
    onContactAddressEvent: (AddressEvent) -> Unit,
    contactAddressValidation: AddressValidation,
    customFieldsState: CustomFieldsState,
    onCustomFieldsEvent: (CustomFieldsEvent) -> Unit,
) {
    LaunchedEffect(isOpen) {
        if (isOpen) {
            // Organization
            onOrganizationEvent(OrganizationEvent.ClearOrganizationState)

            // Contact
            onContactEvent(
                ContactEvent.UpdateContactFields(
                    contact = ContactModel.empty,
                ),
            )

            onContactEvent(
                ContactEvent.AddRemoveAddress(
                    addAddress = false,
                ),
            )

            onCustomFieldsEvent(CustomFieldsEvent.ClearCustomFieldsState)

            onOrganizationEvent(
                OrganizationEvent.UpdateOrganizationFields(
                    organization = organizationState.organization.value.copy(
                        type = type,
                    ),
                ),
            )

            onCustomFieldsEvent(
                CustomFieldsEvent.SetType(
                    type = type,
                ),
            )
        }
    }

    if (isOpen)
        BasicAlertDialog(
            onDismissRequest = onDismissRequest,
            properties = DialogProperties(
                usePlatformDefaultWidth = false,
            ),
            modifier = Modifier.fillMaxSize(0.7f),
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(25.dp)),
            ) {
                Column(
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = Color.White),
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(color = MaterialTheme.esColorScheme.bgPrimary)
                            .padding(vertical = 3.spacing, horizontal = 2.5.spacing),
                    ) {
                        Text(
                            text = "Add a travel agent",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.CenterStart),
                        )

                        EsSmallOutlineIconButton(
                            onClick = {
                                onDismissRequest()
                            },
                            iconRes = EsIcons.Close,
                            modifier = Modifier.align(Alignment.CenterEnd),
                        )
                    }

                    ContactOrganizationScreen(
                        state = state,
                        onEvent = onEvent,
                        organizationState = organizationState,
                        onOrganizationEvent = onOrganizationEvent,
                        organizationValidation = organizationValidation,
                        organizationAddressState = organizationAddressState,
                        onOrganizationAddressEvent = onOrganizationAddressEvent,
                        organizationAddressValidation = organizationAddressValidation,
                        contactState = contactState,
                        onContactEvent = onContactEvent,
                        contactValidation = contactValidation,
                        contactAddressState = contactAddressState,
                        onContactAddressEvent = onContactAddressEvent,
                        contactAddressValidation = contactAddressValidation,
                        customFieldsState = customFieldsState,
                        onCustomFieldsEvent = onCustomFieldsEvent,
                    )
                }
            }
        }
}